// 🔒 PROTECTED — PricePAL Compare
// Owner: Garry Yee | Do not modify without explicit written permission
// See /app/PROTECTED_CODE_REGISTRY.md for full rules
import React from 'react';

/**
 * Skip Navigation Link
 * Allows keyboard/screen reader users to skip directly to main content.
 * Visually hidden until focused.
 */
const SkipNavigation = () => {
  const handleClick = (e) => {
    e.preventDefault();
    const main = document.getElementById('main-content');
    if (main) {
      main.tabIndex = -1;
      main.focus();
      main.removeAttribute('tabindex');
    }
  };

  return (
    <a
      href="#main-content"
      onClick={handleClick}
      className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[9999] focus:px-4 focus:py-2 focus:bg-green-700 focus:text-white focus:rounded-lg focus:shadow-lg focus:text-sm focus:font-semibold focus:outline-none focus:ring-2 focus:ring-green-400 focus:ring-offset-2"
    >
      Skip to main content
    </a>
  );
};

export default SkipNavigation;
